import { handleActions } from '@housinganywhere/safe-redux';

import { Actions, ActionTypes } from '../actions/fetchConversations';
import { ConversationsState as State } from '../types';

const initialState: State = {
  conversations: [],
  status: 'loadingFirstTime',
};

export default handleActions<State, ActionTypes, Actions>(
  {
    [ActionTypes.LOAD_CONVERSATIONS_DONE]: (_, { payload }) => ({
      conversations: payload,
      status: 'success',
    }),
    [ActionTypes.LOAD_CONVERSATIONS_FAIL]: () => ({
      conversations: [],
      status: 'failure',
    }),
    [ActionTypes.LOAD_CONVERSATIONS_START]: () => ({
      conversations: [],
      status: 'loading',
    }),
  },
  initialState,
);
